import {useState} from 'react';

import {useTranslation} from 'react-i18next';

import {Box, Grid, Typography} from '@mui/material';

import CopyrightLink from '../../components/CopyrightLink/CopyrightLink';
import {EmpionButton} from '../../components/EmpionButton/EmpionButton';
import EmpionDialog from '../../components/EmpionDialog/EmpionDialog';
import {CompanyLightQuestionnaire} from '../../features/b2b/CompanyLightQuestionnaire/CompanyLightQuestionnaire';
import {CultureTypeSection} from '../../features/b2b/CultureTypeSection/CultureTypeSection';
import {CustomerSatisfactionSection} from '../../features/b2b/CustomerSatisfactionSection/CustomerSatisfactionSection';
import {FaqSection} from '../../features/b2b/FaqSection/FaqSection';
import {HeroContainer} from '../../features/b2b/HeroContainer/HeroContainer';
import {YourAdvantageSection} from '../../features/b2b/YourAdvantageSection/YourAdvantageSection';
import {useTrackingEvents} from '../../hooks/useTrackingEvents';
import {orangeColors} from '../../layouts/theme/designSystem';
import {TrackingEvents} from '../../types/TrackingEvents';


export const B2BMarketingPage = () => {
  const {t} = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const {eventAttributes} = useTrackingEvents({
    version: TrackingEvents.Version.v1,
    category: TrackingEvents.Category.Marketing,
    action: TrackingEvents.Action.B2BSimplifiedCultureQuestionnaireStarted,
    payload: {
      page: 'b2b_marketing',
      section: 'bottom_cta',
    },
  });

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };


  return (
    <Grid width='100%' borderRadius='5px'>
      <HeroContainer handleCtaClick={toggleModal}/>
      <CultureTypeSection handleCtaClick={toggleModal} />
      <YourAdvantageSection />
      <CustomerSatisfactionSection />
      <FaqSection />
      <Grid width='100%' sx={{px: {xs: 2, sm: 3}, pb: {xs: 5, md: 7}, backgroundColor: '#f5f5f5'}}>
        <Box sx={{maxWidth: '1120px', mx: 'auto', display: 'flex', justifyContent: 'center'}}>
          <EmpionButton
            onClick={toggleModal}
            {...eventAttributes}
            sx={{
              px: 3,
              py: 1.25,
              width: {xs: '100%', sm: 'auto'},
              maxWidth: '432px',
              minHeight: '70px',
              backgroundColor: orangeColors[900],
              '&:hover': {
                backgroundColor: orangeColors[950],
              },
            }}
          >
            <Typography
              component='span'
              sx={{
                color: '#ffffff',
                fontSize: {xs: '1.25rem', sm: '1.5rem'},
                fontWeight: 700,
                lineHeight: 1.5,
                textAlign: 'center',
              }}
            >
              {t('b2b.hero.ctaButton')}
            </Typography>
          </EmpionButton>
        </Box>
      </Grid>
      <CopyrightLink sx={{mt: 4, textAlign: 'center'}} />
      <EmpionDialog open={isModalOpen} onClose={toggleModal} showCloseButton>
        <CompanyLightQuestionnaire />
      </EmpionDialog>
    </Grid>
  );
};
